<lib-ags-loading *ngIf="!syntheseSessionData"></lib-ags-loading>

<div *ngIf="!!syntheseSessionData" class="synthese-contain">
  <div>
    <div uk-grid>
      <div class="uk-align-left uk-width-xxlarge">
        <div uk-grid>
          <div class="uk-width-1-5@m">Formation :</div>
          <div class="uk-width-auto@m" *ngIf="syntheseSessionData">{{ syntheseSessionData.libelle_formation }}</div>
        </div>
        <br />
        <div uk-grid>
          <p class="uk-width-1-5@m">Modalité :</p>
          <p class="uk-width-auto@m">{{ getModalite() }}</p>
        </div>
        <br />
        <div uk-grid *ngIf="syntheseSessionData">
          <p class="uk-width-1-5@m">Durée :</p>
          <p class="uk-width-auto@m">
            {{ hoursSession }} sur {{ daysSession }} {{ daysSession > 1 ? 'jours' : 'jour' }} du
            {{ dateDebut | date: 'dd/MM/yyyy' }} au
            {{ dateFin | date: 'dd/MM/yyyy' }}
          </p>
        </div>
        <br />
        <div uk-grid *ngIf="syntheseSiteData">
          <p class="uk-width-1-5@m">Lieu Principal :</p>
          <p class="uk-width-auto@m">
            {{ syntheseSiteData.adresse }}<br />{{ syntheseSiteData.ville }}<br />
            {{ syntheseSiteData.cp }}
          </p>
        </div>
        <div uk-grid>
          <p class="uk-width-1-5@m">Organisation :</p>
          <p class="uk-width-auto@m">{{ getInter() }}</p>
        </div>
      </div>
      <div class="uk-align-right" *ngIf="syntheseIndicesData">
        <h5 class="uk-align-left">{{ getTitre() }}</h5>
        <div class="uk-align-right">
          <div class="flex-container" *ngIf="syntheseIndicesData.length > 0">
            <div *ngFor="let indices of syntheseIndicesData">
              <p>{{ indices.i_libelle }}</p>
            </div>
          </div>

          <div class="flex-container" *ngIf="syntheseCategoriesData.length > 0">
            <div *ngFor="let categories of syntheseCategoriesData">
              <p>{{ categories.c_code }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />

    <div class="uk-card uk-card-default uk-margin-large-right uk-margin-medium-bottom">
      <div class="uk-card-header uk-padding-small uk-background-muted">
        <div class="uk-width-expand">
          <h3 class="uk-card-title uk-margin-remove-bottom uk-text-meta uk-text-uppercase uk-text-muted">
            Responsable administratif
          </h3>
        </div>
      </div>
      <div class="uk-card-body">
        <div class="uk-grid uk-flex-middle">
          <div class="uk-width-auto">
            <img class="responsive-image" src="{{ syntheseSessionData.photo }}" />
          </div>
          <div class="uk-width-expand">
            <p>
              {{ syntheseSessionData.prenom }} {{ syntheseSessionData.nom }}<br />
              Tél: {{ syntheseSessionData.telephone }} <br />
              <a href="mailto:{{ syntheseSessionData.email }}"> {{ syntheseSessionData.email }}</a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="uk-card uk-card-default uk-margin-large-right uk-margin-medium-bottom">
      <div class="uk-card-header uk-padding-small uk-background-muted">
        <div class="uk-width-expand">
          <h3 class="uk-card-title uk-margin-remove-bottom uk-text-meta uk-text-uppercase uk-text-muted">
            Commanditaire(s)
          </h3>
        </div>
      </div>
      <div class="uk-card-body uk-padding-remove">
        <table class="uk-table uk-table-small uk-table-divider">
          <thead>
            <tr>
              <th>{{ 'Commanditaire' | uppercase }}</th>
              <th>{{ 'Apprenant(s)' | uppercase }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let clients of syntheseClientsData">
              <td>{{ clients.nom_client }}</td>
              <td>{{ clients.nbApprenant }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
